import React from "react";
import { Button } from "reactstrap";
function companyToggle({ id, isVerified, companyName, submit }) {
  return (
    <div>
      <Button
        color={isVerified ? "primary" : "danger"}
        className={isVerified ? "pe-4 btn-sm" : "btn-sm"}
        onClick={() =>
          submit({
            companyId: id,
            companyName: companyName,
            isVerified: !isVerified,
          })
        }
      >
        {isVerified ? "Is Verified" : "Not Verified"}
      </Button>
    </div>
  );
}

export default companyToggle;
